import { Component, OnInit } from '@angular/core';
export class NavComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'oneui-nav',
  template: `
    <p>
      nav works!
    </p>
  `,
  styles: [`

  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NavComponent_tsickle_Closure_declarations() {
/** @type {?} */
NavComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NavComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
